import TopHeader from './headers/top'
import BottomHeader from './headers/bottom';
import Style from './style.module.css'

const Header = ({topTabs, bottomTabs, isBottom = true , className}) => {
  return (
    <header className={`${Style.siteHeader} ${className?.siteHeader}`}>
      <TopHeader topTabs={topTabs} style={Style} className={className} />
      {isBottom &&
        <BottomHeader bottomTabs={bottomTabs} style={Style} />
      }
    </header>
  )
}

export default Header
